export const CREATED: string = 'Created'; // used for orders, totem, categories
export const ARCHIVED: string = 'Archived'; // used for totems, orders, products
export const INPROGRESS: string = 'InProgress'; // used for orders, deliveries
export const ABORTED: string = 'Aborted'; // used for deliveries
export const NOT_DELIVERED: string = 'NotDelivered'; // used for deliveries

// only used for products
export const REGULAR: string = 'Regular';

// only used for orders
export const PAUSED: string = 'Paused';
export const VALIDATED: string = 'Validated';
export const READY: string = 'Ready';

// only used for deliveries
export const DELIVERED: string = 'Delivered';

export const MODIFIABLE_ORDER_STATES: string[] = [CREATED, INPROGRESS, VALIDATED, PAUSED];
